import { useRouteError } from "react-router-dom";
import { Button, Result } from "antd";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { posthog } from "../lib/posthog";

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  padding: 24px;
`;

export const ErrorBoundary = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    if (error) {
      // Track router-level errors
      posthog.capture("$exception", {
        error_message: error.message,
        error_name: error.name,
        error_stack: error.stack,
        error_source: "router_error_boundary",
        error_severity: "high",
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        url: window.location.href,
        pathname: window.location.pathname,
      });

      posthog.capture("router_error_boundary_triggered", {
        error_message: error.message,
        error_name: error.name,
        timestamp: new Date().toISOString(),
      });

      console.error("Router error captured:", error);
    }
  }, [error]);

  return (
    <ErrorContainer>
      <Result
        status="error"
        title="Oops! Something went wrong"
        subTitle={error?.message || "An unexpected error occurred"}
        extra={[
          <Button type="primary" key="home" href="/">
            Go Home
          </Button>,
        ]}
      />
    </ErrorContainer>
  );
};
